import { styled } from '@mui/material';
import React from 'react';
import UserLimitContent from './UserLimitContent';
import {
  GeneralSetting,
  GeneralSettingType,
  MainFeature,
} from '../../../types';
import AreaLimitContent from './AreaLimitContent';
import AlertNotificationContent from './AlertNotificationContent';
import HeatstrokeAlertDebounceContent from './HeatstrokeAlertDebounceContent';
import OfflineDetection from './OfflineDetection';

const Container = styled('div')`
  padding: 0 36px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  & > .errorMessage {
    color: #ff6b00;
    font-size: 0.75rem;
  }
`;

interface GeneralProps {
  mainFeatureType: MainFeature;
  generalSetting: GeneralSetting;
  handleOnChangeGeneral: (
    type: GeneralSettingType,
    metadata: any,
  ) => Promise<void>;
}
const General: React.FC<GeneralProps> = ({
  mainFeatureType,
  generalSetting,
  handleOnChangeGeneral,
}) => {
  return (
    <Container>
      <UserLimitContent
        userLimit={generalSetting.userLimit}
        onChange={(data) => {
          handleOnChangeGeneral('user-limit', data);
        }}
        mainFeatureType={mainFeatureType}
      />
      <AreaLimitContent
        areaLimit={generalSetting.areaLimit}
        onChange={(value: number | undefined) => {
          handleOnChangeGeneral('area-limit', value);
        }}
        mainFeatureType={mainFeatureType}
      />
      <AlertNotificationContent
        msgTitle={generalSetting.msgTitle}
        onChange={(value: string | undefined) => {
          handleOnChangeGeneral('alert-notification', value);
        }}
      />
      <HeatstrokeAlertDebounceContent
        alertDebounceInSec={generalSetting.alertDebounceInSec}
        heatstrokeAlertDebounceInSec={
          generalSetting.heatstrokeAlertDebounceInSec
        }
        onChange={(data) => {
          handleOnChangeGeneral('heatstroke-alert-debounce', data);
        }}
      />
      <OfflineDetection
        onChange={(data) => {
          handleOnChangeGeneral('offline-detection', data);
        }}
        deviceOfflineInterval={generalSetting.deviceOfflineInterval}
        deviceSleepInterval={generalSetting.deviceSleepInterval}
      />
    </Container>
  );
};

export default General;
